import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment as env } from '@env/environment';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/AuthenticationService';
import { IDiscountCode } from '../interfaces/IDiscountCode';

@Injectable({
  providedIn: 'root',
})
export class DiscountCodeService {
  private apiBaseUrl: string = env.hostApi + 'DiscountCode';
  private httpOptions: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    this.updateHttpOptions();
  }

  private updateHttpOptions() {
    const token = this.authenticationService.token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
    };
  }

  getAll(): Observable<IDiscountCode[]> {
    return this.http.get<IDiscountCode[]>(this.apiBaseUrl, { headers: this.httpOptions.headers }).pipe(
      tap((response) => console.log('Fetched discount codes', response)),
      catchError((err) => throwError(() => new Error(err)))
    );
  }

  getById(id: number): Observable<IDiscountCode> {
    return this.http.get<IDiscountCode>(`${this.apiBaseUrl}/${id}`, { headers: this.httpOptions.headers }).pipe(
      tap((response) => console.log('Fetched discount code', response)),
      catchError((err) => throwError(() => new Error(err)))
    );
  }

  create(discountCode: IDiscountCode): Observable<IDiscountCode> {
    return this.http.post<IDiscountCode>(this.apiBaseUrl, discountCode, { headers: this.httpOptions.headers }).pipe(
      tap((response) => console.log('Created discount code:', response)), // Logs the response
      catchError((response: HttpErrorResponse) => {
        debugger
        alert(response.error)
        return throwError(() => response); // Preserve the original error response
      })
    );
  }


  update(id: number, discountCode: IDiscountCode): Observable<any> {
    return this.http.put<any>(`${this.apiBaseUrl}/${id}`, discountCode, { headers: this.httpOptions.headers }).pipe(
      tap((response) => console.log('Updated discount code:', response)), // Ensure this logs the actual response
      catchError((response: HttpErrorResponse) => {
        alert(response.error)
        return throwError(() => response); // Preserve error details
      })
    );
  }



  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiBaseUrl}/${id}`, { headers: this.httpOptions.headers }).pipe(
      tap(() => console.log('Deleted discount code', id)),
      catchError((err) => throwError(() => new Error(err)))
    );
  }
}
